import { Component, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ButtonTypes } from '@app/shared/enums/buttonTypes.enum';

interface SignupFormGroup {
  email: FormControl<string|null>;
}

@Component({
  selector: 'app-callout-signup',
  templateUrl: 'callout-signup.component.html'
})
export class CalloutSignupComponent {
  constructor(
    public formBuilder: FormBuilder,
    private router: Router
  ) {}

  buttonTypesEnum = ButtonTypes;
  // form: FormGroup<SignupFormGroup> = this.formBuilder.group<SignupFormGroup>({
  //   email: this.formBuilder.control(null, Validators.required)
  // });
  signupLink:string = 'https://madmimi.com/signups/4917cbfde53f46fdaf2efe03b33cb2d3/join';

  ngOnInit() {}

  // handleButtonClick():void {
  //   this.router.navigate(["about"]);
  // }
}
